/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface NewsletterListItemSendTimeArgs {
  isSent: boolean;
  sending: boolean;
  sentTime: number;
  scheduledTime: number;
  scheduledTimeZone: string;
  tzMatchEnabled: boolean;
}

export default class NewsletterListItemSendTime extends Component<NewsletterListItemSendTimeArgs> {}
